<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ assistant.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <AssistantTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <CButton color="primary" @click="addExtra">Добавить</CButton>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <draggable v-model="extras" tag="tbody">
                                <tr v-for="extra in extras" :key="extra.id">
                                    <td>
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle"
                                        />
                                    </td>
                                    <td>{{ extra.title }}</td>
                                    <td>{{ extra.price }}</td>
                                    <td>
                                        <CButton
                                            @click="editExtra(extra)"
                                        ><CIcon
                                            :content="$options.icons.cilPencil"
                                            class="handle"
                                        /></CButton>
                                        <CButton
                                            @click="removeExtra(extra)"
                                        ><CIcon
                                            :content="$options.icons.cilTrash"
                                            class="handle"
                                        /></CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="info"
                        class="mr-3"
                        @click="save"
                    >Сохранить порядок</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <AssistantExtraUpsertDialog
            ref="upsertDialog"
            :entity="selectedExtra"
            @success="fetch" />

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Действительно удалить? Это действие нельзя будет отменить."
            @confirm="confirmDelete"
        />
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import to from 'await-to-js'
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';

    import AssistantTabLinks from '@/components/assistant/AssistantTabLinks';
    import AssistantExtraUpsertDialog from '@/components/assistant/AssistantExtraUpsertDialog';
    import AppConfirmDialog from '@/components/AppConfirmDialog';

    export default {
        name: 'AssistantExtras',

        components: {
            AssistantTabLinks,
            AssistantExtraUpsertDialog,
            AppConfirmDialog,
            draggable,
        },

        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil,
        },

        data() {
            return {
                assistant: {
                    title: '',
                },
                extras: [],
                selectedExtra: {},
            };
        },

        computed: {},

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = parseInt(this.$route.params.id);
                Vue.axios
                    .get('/assistants/' + id)
                    .then(resp => {
                        this.assistant = resp.data;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
                Vue.axios
                    .get('/assistants/' + id + '/extras')
                    .then(resp => {
                        this.extras = resp.data;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },

            save() {
                const extrasToSave = [];
                let index = 0;
                this.extras.forEach(extra => {
                    extrasToSave.push({
                        id: extra.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post('/assistants/' + this.assistant.id + '/extras/reorder', {
                        reorder: extrasToSave,
                    })
                    .then(resp => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },

            addExtra() {
                this.selectedExtra = {
                    assistant_id: this.assistant.id
                };
                this.$refs.upsertDialog.open();
            },

            editExtra(extra) {
                this.selectedExtra = extra;
                this.$refs.upsertDialog.open();
            },

            removeExtra(extra) {
                this.selectedExtra = extra;
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.selectedExtra.id) {
                    return false
                }

                const [error] = await to(this.axios.delete(`/assistants/${this.selectedExtra.assistant_id}/extras/${this.selectedExtra.id}`))

                if (error) {
                    return this.$root.$emit('showError', 'ошибка при удалении. ' + error)
                }

                await this.fetch();
            },

            goBack() {
                this.$router.push({ path: '/assistants/' + this.$route.params.id });
            },
        },
    };
</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>
